// extracted by mini-css-extract-plugin
export default {"origin":"ResultOrigin_origin__Yt0QC","card-bank":"ResultOrigin_card-bank__zuaXD","color":"ResultOrigin_color__rbXj+"};